"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueueProcessMode = exports.OperationsChannel = void 0;
var ErrorCodes_1 = require("@CommonFrontendBackend/ErrorCodes/ErrorCodes");
var HTTP_MESSAGES_1 = require("@CommonFrontendBackend/Utils/HTTP_MESSAGES");
var QueueProcessor_1 = __importStar(require("./QueueProcessor"));
Object.defineProperty(exports, "QueueProcessMode", { enumerable: true, get: function () { return QueueProcessor_1.QueueProcessMode; } });
var OperationsChannel = (function () {
    function OperationsChannel($http, $log, endpoint, startingPersistVersion, conflictResolver, onFinishedProcessing, onError, onRetry, processMode, $state, showAcknowledgeModal) {
        if (processMode === void 0) { processMode = QueueProcessor_1.QueueProcessMode.OneByOne; }
        var _this = this;
        this.$http = $http;
        this.$log = $log;
        this.endpoint = endpoint;
        this.conflictResolver = conflictResolver;
        this.onFinishedProcessing = onFinishedProcessing;
        this.onError = onError;
        this.onRetry = onRetry;
        this.$state = $state;
        this.showAcknowledgeModal = showAcknowledgeModal;
        this.hasRetried = false;
        this.handleProcessingDone = function () {
            _this.onFinishedProcessing(_this.version, _this.hasRetried);
            _this.hasRetried = false;
        };
        this.processTask = function (task) { return __awaiter(_this, void 0, Promise, function () {
            var error_1, errorMessage, _a, newVersion, conflictResolution, explainer;
            var _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 2, , 3]);
                        return [4, this.$http.post(this.endpoint, {
                                update: task.payload,
                                applyTo: this.version,
                            })];
                    case 1:
                        _g.sent();
                        this.version++;
                        return [2, { handled: true }];
                    case 2:
                        error_1 = _g.sent();
                        errorMessage = (_f = (_c = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : (_e = (_d = error_1 === null || error_1 === void 0 ? void 0 : error_1.data) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e.message) !== null && _f !== void 0 ? _f : "";
                        if (errorMessage === ErrorCodes_1.ErrorCodes.COLLAB_HAVE_OLD_VERSION) {
                            _a = this.conflictResolver(error_1.data, this.queueProcessor.pendingTasks), newVersion = _a.newVersion, conflictResolution = _a.conflictResolution;
                            this.version = newVersion;
                            return [2, { handled: true, additionalTasks: conflictResolution }];
                        }
                        if ([ErrorCodes_1.ErrorCodes.PROJECT_NOT_EDITABLE, ErrorCodes_1.ErrorCodes.PROJECT_ACCEPTED].includes(errorMessage)) {
                            explainer = errorMessage === ErrorCodes_1.ErrorCodes.PROJECT_ACCEPTED
                                ? "This project has been accepted and can no longer be edited"
                                : "This project has been accepted or declined and can no longer be edited";
                            this.$state.go("dashboard", { nav: "pages" });
                            this.showAcknowledgeModal({ title: "".concat(errorMessage), explainer: explainer });
                            this.hasRetried = false;
                            return [2, { handled: true, pause: true }];
                        }
                        if ((error_1 === null || error_1 === void 0 ? void 0 : error_1.status) === -1) {
                            this.hasRetried = true;
                            this.onRetry(HTTP_MESSAGES_1.ERROR_NETWORK_DISCONNECTED);
                            return [2, { handled: false, retryDelay: 2000 }];
                        }
                        this.onError("We had an issue with processing your update");
                        this.$log.error(error_1);
                        return [2, { handled: false }];
                    case 3: return [2];
                }
            });
        }); };
        this.version = startingPersistVersion;
        this.queueProcessor = new QueueProcessor_1.default({
            processor: this.processTask,
            onDone: this.handleProcessingDone,
            processMode: processMode,
        });
    }
    OperationsChannel.prototype.sendOperation = function (operation) {
        this.queueProcessor.enqueue(operation);
    };
    OperationsChannel.prototype.getVersion = function () {
        return this.version;
    };
    OperationsChannel.prototype.updateVersion = function (newVersion) {
        this.version = newVersion;
    };
    return OperationsChannel;
}());
exports.OperationsChannel = OperationsChannel;
